/**
 * Main entry point for @vtdr/shared package
 */

const timeUtils = require('./timeUtils');
const constants = require('./constants');

module.exports = {
  ...timeUtils,
  ...constants,
};

